import axios from 'axios';
import { API_UPDATE_REPORT_FRAME } from '../../../endpoint';
import {
  checkCancelToken,
  consolelog,
  delCancelToken,
} from '../../../../lib/tools';
import {
  createCancelToken,
  handleErrorResponse,
  i18nMessages,
} from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';
import { OPEN_USER_PROMPT } from '../../../actionTypes';

/**
 * 報告書のフレームを更新する。
 *
 * @param {string} apiToken - APIトークン
 * @param {string} groupId - グループID。このグループに紐づく報告書一覧を取得する。
 * @param {string} reportId - 報告書ID。この報告書に紐づくフレームを作成する。
 * @param {string} frameId - フレームID。このフレームを更新する。
 * @param {object} requestBody - リクエスト項目。
 * @returns {Function} dispatch - Redux dispatch関数
 */
const updateReportFrame =
  (apiToken, groupId, reportId, frameId, requestBody, lastModifiedDate) =>
  async dispatch => {
    if (groupId == null || reportId == null || frameId == null) {
      return null;
    }
    consolelog('[API CALL] updateReportFrame()', apiToken);
    configureAxiosForJSON(apiToken);

    // キャンセルトークンの設定
    const { cancelToken, cancelTokenKey } =
      createCancelToken('updateReportFrame');

    // urlの設定
    const url = API_UPDATE_REPORT_FRAME.replace('{groupId}', groupId)
      .replace('{reportId}', reportId)
      .replace('{frameId}', frameId);

    // axiosの設定オプション
    const axiosConfig = {
      headers: {
        'If-Unmodified-Since': lastModifiedDate,
      },
      cancelToken,
    };

    try {
      const res = await axios.put(url, requestBody, axiosConfig);
      if (checkCancelToken(cancelTokenKey) && res.status === 200) {
        dispatch({ type: 'SUCCESS_API_UPDATE_FRAME', payload: res.data });
        return res;
      }
      return null;
    } catch (thrown) {
      if (thrown.response?.status === 412) {
        return thrown;
      }
      if (thrown.response?.status === 404) {
        const promptMessage = [
          i18nMessages['userPrompt.message.reportEdit.frameDeleted1'],
          i18nMessages['userPrompt.message.reportEdit.frameDeleted2'],
        ];
        const close = [{ name: i18nMessages['userPrompt.button.close'] }];
        dispatch({
          type: OPEN_USER_PROMPT,
          promptMessage,
          buttonArray: close,
        });
        return thrown;
      }
      handleErrorResponse(
        thrown,
        dispatch,
        '',
        i18nMessages['userPrompt.message.reportEdit.frameDeleted1'],
      );

      return thrown;
    } finally {
      delCancelToken(cancelTokenKey);
    }
  };

export default updateReportFrame;
